import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const ImgTextSlider = ({ blok }) => (
    <div className="wrap">
    <div className="slider-wrap inner-wrap flex" {...storyblokEditable(blok)}>

    <div className="slider-text-wrap flex flex-col">
      <h2 className="slider-headline text-2xl">
        {blok.subheadline}
      </h2>
      <div className="slider-wrap-right flex">
      <div className="slider-content flex flex-col">
        <h3 className="text-xl">{blok.captionleft}</h3>
        <div className="slider-text">
          <p>
          {blok.textleft}
          </p>
          {blok.textleft2 && (<p className="pt-2">
          {blok.textleft2}
          </p>)}
        </div>

        <div className="slider-wrap-left flex">
          <div className="slider-image">
            <img src={blok.imageslider.filename} alt={blok.imageslider.alt}/>
          </div>
        </div>  
        
        <Link href={blok.leftbuttonlink} target="_blank" >
          <button className="slider-btn">{blok.leftbutton}</button>
        </Link>
      {/*   <div className="slider-image flex justify-center">
          <img src={blok.imageslider.filename} alt={blok.imageslider.alt}/>
        </div> */}
      </div>
      <div className="slider-content second-content flex flex-col">
      <h3 className="text-xl">{blok.captionright}</h3>
        <div className="slider-text2">
          <p>
          {blok.textright}
          </p>
          {blok.textright2 && (<p className="pt-2">
          {blok.textright2}
          </p>)}
        </div>
        <Link target="_blank" href={blok.rightbuttonlink} >
          <button className="slider-btn">{blok.rightbutton}</button>
          
        </Link>
        
        {/* <div className="slider-image flex justify-center">
          <img src={blok.imageslider.filename} alt={blok.imageslider.alt}/>
        </div> */}
      </div>

      <div className="slider-content second-content flex flex-col">
      <h3 className="text-xl">{blok.captionright2}</h3>
        <div className="slider-text2">
          <p>
          {blok.textright3}
          </p>
          {blok.textright4 && (<p className="pt-2">
          {blok.textright4}
          </p>)}
        </div>
        
        {blok.rightbutton2 &&
        <Link target="_blank" href={blok.rightbuttonlink2} >
          <button className="slider-btn">{blok.rightbutton2}</button>
          
        </Link>
        }
        
        {/* <div className="slider-image flex justify-center">
          <img src={blok.imageslider.filename} alt={blok.imageslider.alt}/>
        </div> */}
      </div>
      </div>
      
    </div>
  </div>
  </div>
);

export default ImgTextSlider;

/*function ImgTextSlider() {
  return (
    <div className="slider-wrap px-48 py-8 flex">
      <div className="slider-wrap-left flex flex-col">
        <h2 className="slider-headline text-2xl">
          Neuigkeiten für Gastronomen
        </h2>
        <div className="slider-content">
          <div className="slider-image">
            <img src="src/wirtshaus_innenaufnahme.jpg" alt="test" />
          </div>
          <div className="slider-text">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi odit
              adipisci aspernatur nostrum? Ipsa molestias odio cum consectetur,
              nam quibusdam natus enim eveniet repellendus totam, quis iusto
              veniam quidem aspernatur.
            </p>
          </div>
        </div>
      </div>

      <div className="slider-text-wrap flex flex-col ml-10">
        <h2 className="slider-headline text-2xl">
          Neuigkeiten für Gastronomen
        </h2>
        <div className="slider-content flex flex-col">
          <div className="slider-text2">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi odit
              adipisci aspernatur nostrum? Ipsa molestias odio cum consectetur,
              nam quibusdam natus enim eveniet repellendus totam, quis iusto
              veniam quidem aspernatur.Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Nisi odit adipisci aspernatur nostrum? Ipsa
              molestias odio cum consectetur, nam quibusdam natus enim eveniet
              repellendus totam, quis iusto veniam quidem aspernatur.Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Nisi odit adipisci
              aspernatur nostrum? Ipsa molestias odio cum consectetur, nam
              quibusdam natus enim eveniet repellendus totam, quis iusto veniam
              quidem aspernatur.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImgTextSlider;
 */